import firebase from "./Firebase.service";

const cloudStorageUpload = async (file, folderPath="", changeHandler=()=>{}, fileUploadUrl=()=>{}) => {
  
    try {
        changeHandler(10);
        
        var storageRef = firebase.storage().ref();
        
        const fileName = `${folderPath}/${Date.now()}__${file.name}`;
        
        let imageStoreRef = storageRef.child(fileName);

        let uploadTask = imageStoreRef.put(file);

         uploadTask.on(
            "state_changed",
            snapshot => {
                const progress = Math.round( (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                changeHandler(progress < 10 ? 10 : progress);
            },
            error => {
                console.log('error while upload', error);
            },
            () => {
                imageStoreRef.getDownloadURL().then((downloadURL) => {
                    changeHandler(null);
                    console.log('uploaded url', downloadURL);
                    fileUploadUrl(downloadURL)
                    Promise.resolve(downloadURL);
                })
            }
        )
        
    } catch (error) {
        console.log('cloudStorageUpload failed => ', {error, file, folderPath});
        return null
    }
}

export const uploadTourPoster = async (file, changeHandler, fileUploadUrl) => {
    const FOLDER_PATH = "tour-poster";
    return await cloudStorageUpload(file, FOLDER_PATH, changeHandler, fileUploadUrl);
}

export const uploadScenePanoImage = async (file, changeHandler, fileUploadUrl) => {
    const FOLDER_PATH = "scene-pano-image";
    return await cloudStorageUpload(file, FOLDER_PATH, changeHandler, fileUploadUrl);
}

export const uploadSceneAudio = async (file, changeHandler, fileUploadUrl) => {
    const FOLDER_PATH = "scene-audio";
    return await cloudStorageUpload(file, FOLDER_PATH, changeHandler, fileUploadUrl);
}

export const uploadHotspotAudio = async (file, changeHandler, fileUploadUrl) => {
    const FOLDER_PATH = "hotspot-audio";
    return await cloudStorageUpload(file, FOLDER_PATH, changeHandler, fileUploadUrl);
}

export const uploadHotspotVideo = async (file, changeHandler, fileUploadUrl) => {
    const FOLDER_PATH = "hotspot-video";
    return await cloudStorageUpload(file, FOLDER_PATH, changeHandler, fileUploadUrl);
}

export const uploadHotspotImage = async (file, changeHandler, fileUploadUrl) => {
    const FOLDER_PATH = "hotspot-image";
    return await cloudStorageUpload(file, FOLDER_PATH, changeHandler, fileUploadUrl);
}

export default cloudStorageUpload;